import clsx from 'clsx'

import {
    HEADING_5_STYLES,
    LABEL_STYLES,
    LinkButton,
    PARAGRAPH_SMALL_STYLES,
} from '../design-system'
import { getRotatedGradientColors, twMerge } from '../tailwind-css'

interface BlogPostCardProps {
    color: 'blue' | 'purple' | 'green' | 'yellow'
    label?: string
    title: string
    description?: string | readonly string[]
    ctaUrl: string
}

export function BlogPostCard({ color, label, title, description, ctaUrl }: BlogPostCardProps) {
    return (
        <article
            className={clsx(
                'p-8 rounded-3xl',
                {
                    blue: 'bg-blue-100',
                    purple: 'bg-purple-100',
                    green: 'bg-green-50',
                    yellow: 'bg-yellow-50',
                }[color]
            )}
            style={getRotatedGradientColors(color)}
        >
            <div className="sm:w-4/5">
                {label && <p className={twMerge(LABEL_STYLES, 'text-grey-700/60 pb-1')}>{label}</p>}
                <h2 className={HEADING_5_STYLES}>{title}</h2>
            </div>
            {description &&
                (typeof description === 'string' ? (
                    <p className={twMerge(PARAGRAPH_SMALL_STYLES, 'pt-4')}>{description}</p>
                ) : (
                    description.map((d, index) => (
                        <p key={index} className={twMerge(PARAGRAPH_SMALL_STYLES, 'pt-4')}>
                            {d}
                        </p>
                    ))
                ))}

            <div className="-mb-2 pt-6">
                <LinkButton href={ctaUrl} arrowRight alignLeft>
                    Read more
                </LinkButton>
            </div>
        </article>
    )
}
